import React, { useContext, useEffect } from 'react'
import { useKnowledgeBaseStore } from '../../../../store/knowledgeBaseStore';
import { UserContext, UserContextPayload } from '../../../../context/userContext';
import { Grid, useMediaQuery } from '@mui/material'; 
import globalStyles from "../../../../assets/styles/global.module.scss";
import KnowledgeBaseTable from './knowledgeBaseTable';
import GlobalPopUp from '../../../utility/globalPopUp';
import UploadKnowledgeBaseFilePopup from './uploadKnowledgeBaseFilePopup';

const KnowledgeBase = () => {
    
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;

    const knowledgeBaseFiles = useKnowledgeBaseStore((state) => state.knowledgeBaseFiles);
    const getKnowledgeBaseFilesApi = useKnowledgeBaseStore((state) => state.getKnowledgeBaseFilesApi); 
    const flagUploadKnowledgeBaseFilePopup = useKnowledgeBaseStore((state) => state.flagUploadKnowledgeBaseFilePopup); 
    const setFlagUploadKnowledgeBaseFilePopup = useKnowledgeBaseStore((state) => state.setFlagUploadKnowledgeBaseFilePopup);  

    const breakPoints = {
        smallScreen: useMediaQuery<boolean>('(max-width : 600px) and (min-width : 0px)'),
        flagTabletScreen: useMediaQuery<boolean>('(max-width : 900px) and (min-width : 600px)'),
        flagSmallScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1000px)'),
        flagLaptopScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1550px)')
    }
    
    const getKnowledgeBaseFilesApiCall = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const res = await getKnowledgeBaseFilesApi(); 
        if(!(res.status)){
            handleError(res);
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    useEffect(() => {
        getKnowledgeBaseFilesApiCall();
    }, []);

    return (
        <>
            <Grid container direction={"column"} gap={2}>
                <Grid item xs={12} className={globalStyles.fullwidth}>
                    <KnowledgeBaseTable
                        getKnowledgeBaseFilesApiCall={getKnowledgeBaseFilesApiCall}
                    />
                </Grid>
            </Grid> 

            {flagUploadKnowledgeBaseFilePopup && 
                <GlobalPopUp
                    open={flagUploadKnowledgeBaseFilePopup}
                    onClose={() => { setFlagUploadKnowledgeBaseFilePopup(false); }}
                    handleClose={() => { setFlagUploadKnowledgeBaseFilePopup(false); }}
                    flagShowCloseIcon={true}
                    // flagBackdrop
                    paperMinWidth={breakPoints.flagSmallScreen ? "300px" : "700px"}
                    paperMaxwidth={breakPoints.flagSmallScreen ? "710px" : "800px"}
                    borderRadius='10px'
                    titlePadding='0px'
                    overflow="hidden"
                >
                    <UploadKnowledgeBaseFilePopup
                        getKnowledgeBaseFilesApiCall={getKnowledgeBaseFilesApiCall}
                    />
                </GlobalPopUp>
            }
        </>
    )
}

export default KnowledgeBase
